function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), React.createElement("g", {
  fill: "none"
}, React.createElement("circle", {
  cx: "12",
  cy: "12",
  r: "12",
  fill: "#68D4F8"
}), React.createElement("path", {
  fill: "#217AB7",
  d: "M14.18.2L8.3 5.89a1 1 0 00-.3.7V8h7a1 1 0 011 1v7h1.4a1 1 0 00.71-.3l5.71-5.8A12 12 0 0014.18.2z"
}), React.createElement("path", {
  fill: "#FFF",
  d: "M16 17.4V16H9a1 1 0 01-1-1V8H6.6a1 1 0 00-.71.3l-4.5 4.5a1 1 0 00-.28.83 11 11 0 009.2 9.26 1 1 0 00.83-.28l4.55-4.5a1 1 0 00.31-.7z"
}))));